const min = (value, len) => (value && value.length >= len) || `Min ${len} characters.`

export default {
  required: value => !!value || 'Required.',
  min1: value => min(value, 1),
  min5: value => min(value, 5),
  min25: value => min(value, 25)
}
